import { render, staticRenderFns } from "./CmgAddRewardModal.vue?vue&type=template&id=37593d99&scoped=true&lang=pug"
import script from "./cmg-add-reward-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-add-reward-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAddRewardModal.vue?vue&type=style&index=0&id=37593d99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37593d99",
  null
  
)

export default component.exports